export enum FileGenerationStatusType {
    NotApplicable = 0,
    ToBeGenerated = 1,
    GenerationOk = 2,
    GenerationFailed = 3,
}
